<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLongTitle"></h5>
      <button
        id="formModalClose"
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" v-if="formData.formType">
      <!-- INSERT CRUD FORM HERE -->
      <SimpleForm
        v-if="dataFields.externalResource"
        :param="formData.param"
        :index="formData.index"
        :name="formData.name"
        :formType="formData.formType"
      ></SimpleForm>

      <extended-info
        v-else
        :param="formData.param"
        :itemIdName="formData.itemIdName"
        :index="formData.index"
        :name="formData.name"
        :formType="formData.formType"
      ></extended-info>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// Components
import ExtendedInfo from '../CRUDs/ExtendedInfo.vue';
import SimpleForm from '../CRUDs/SimpleForm.vue';
// JSON
import dataFields from '../../data/schemas/CRUD_data_structure.json';

export default {
  props: [],
  components: {
    ExtendedInfo,
    SimpleForm,
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels,
      formData: (state) => state.products.formData,
    }),
    dataFields() {
      return dataFields[this.formData.param];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Modals/FormModal.vue